import getOriginalCountryOfOrigin from '../utilities/country-of-origin';

// returns data if the new P3 data does not match what was stored in SCS
const compareP3Data = (scdData, p3Data) => {
    const orderValidations = [];

    scdData.forEach(order => {
        let validations = {};
        let hasChanges = false;

        const p3Order = p3Data.find(item => item.purchaseOrderDetailId === order.poDetailId);
        
        if (p3Order) {
            validations.poDetailId = order.poDetailId

            if (parseInt(order.originalQty) !== parseInt(p3Order.qty)) {
                hasChanges = true;
                validations.originalQty = p3Order.qty;
            }
    
            if (parseFloat(order.originalPrice) !== parseFloat(p3Order.price)) {
                hasChanges = true;
                validations.originalPrice = p3Order.price;
            }
    
            const p3CountryOfOrigin = getOriginalCountryOfOrigin(p3Order);   
            console.log(`The original COO is ${order.originalCountryOfOrigin} and the p3 COO is ${p3CountryOfOrigin}`);
            
            if (order.originalCountryOfOrigin !== p3CountryOfOrigin) {
                hasChanges = true;
                validations.originalCountryOfOrigin = p3CountryOfOrigin;
            }
        }
  
        if (hasChanges) orderValidations.push(validations);
    });

    return orderValidations;
}

export default compareP3Data;